import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import { MoveToArchiveFormValues } from "src/models/Inquiry.model";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";

type Props = {
  formikProps: FormikProps<MoveToArchiveFormValues>;
  onClose: () => void;
};

const reasonType = [
  {
    label: "Convert",
    value: "Convert",
  },
  {
    label: "Lost",
    value: "Lost",
  },
];

const MoveToArchiveForm = ({ formikProps, onClose }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium"> Move to Archive</div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        {/* Reason */}
        <div className="">
          <ATMSelect
          required
            name="reason"
            value={values?.reason}
            onChange={(newValue) => setFieldValue("reason", newValue)}
            onBlur={handleBlur}
            label="Reason"
            placeholder="Select Reason"
            options={reasonType}
          />
        </div>
        {/* Description */}
        <div className="">
          <ATMTextArea
            name="description"
            value={values?.description || ""}
            onChange={(e: any) => setFieldValue("description", e)}
            label="Description"
            placeholder="Enter Description"
            onBlur={handleBlur}
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default MoveToArchiveForm;
